exports = module.exports = require("../../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1Yvryp7LbFZZ8yu86_EN1u:first-of-type{padding-top:15px;padding-left:10px;padding-right:10px}._1Yvryp7LbFZZ8yu86_EN1u:not(:first-of-type){padding-top:5px;padding-left:10px;padding-right:10px}", ""]);

// exports
exports.locals = {
	"licenseNotification": "_1Yvryp7LbFZZ8yu86_EN1u"
};


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/node_modules/css-loader!./src/web/notifications/LicenseNotification.css
// module id = 541
// module chunks = 0